<template lang="pug">
.v-field-schedule
	.field-label.field-schedule__label(v-if="field.label") {{field.label}}

		transition(name="fade")
			transition-group.field-schedule__container(tag="div" name="content-fade")
				template(v-for="(item, ind) in localDays" :key="ind")
					.field-schedule__content
						.field-schedule__list
							template(v-for="(checkbox, index) in field.day" :key="index" )
								.field-schedule__checkbox
									v-field-checkbox(
										:true-value="checkbox.value"
										:text="checkbox.text"
										:disabled="matrix[ind][index].disabled"
										v-model="matrix[ind][index].value"
										@update:model-value="updateDisabled(ind); emmitData()"
										)
						.field-schedule__fields
							.field-schedule__field
								v-field(:field="{type: 'select-time', placeholder: item.placeholderStartTime, dayOff: item.dayOff }" v-model="item.startTime" v-model:day-off="item.dayOff.value" @update:model-value="emmitData" @update:day-off="dayOffHandler; emmitData()")
							.field-schedule__field
								v-field(:field="{type: 'select-time', placeholder: item.placeholderBreaks, disabled: item.breaksDisabled }" v-model="item.breaks"  @update:model-value="emmitData" )
						.field-schedule__coment(v-if="item.comment")
							v-field(:field="item.comment" v-model="item.comment.value" @update:model-value="emmitData")
						button.btn.btn--primary.btn--sm.field-schedule__remove(v-if="matrix.length > 1" @click="remove(ind); emmitData()" type='button') {{field.remove}}
		transition(name="fade")
			.field-schedule__action(v-if="computedAvailableButton && computedCheckLastChange")
				button.field-schedule__action-btn(@click="addSchedule" type='button') {{field.addButton}}
</template>

<script>
	import uniqueId from '../scripts/helpers/uniqueId.js';
	import {cloneDeep} from 'lodash';

	export default  {
		emits: [
			'update:model-value',
			'emmitData'
		],
		props: {
			field: {
				type:Object,
				default: null
			},
			modelValue: {
				type: [Object, String, Number, Boolean, Symbol, Date],
				default: null
			},
		},

		data() {
			return {
				localDays: [],

				localValue: [],
				localSchedule: {},
				mapOptions: [],

				matrix: [
					[
						{disabled: false, value: false},
						{disabled: false, value: false},
						{disabled: false, value: false},
						{disabled: false, value: false},
						{disabled: false, value: false},
						{disabled: false, value: false},
						{disabled: false, value: false}
					]
				],
				emptyModel: null,

				changeValues: null,
				mapSchedule: []
			}
		},



		methods: {

			dayOffHandler() {

			},

			remove(ind) {
				this.matrix.splice(ind, 1);
				this.localDays.splice(ind, 1);
				this.updateDisabled(ind);
			},

			colapceMatrix() {
				const collapsedArray = new Array(7).fill(false)

				for(let i = 0; i < this.matrix.length; i++) {
					for(let j = 0; j < this.matrix[i].length; j++) {
						if (this.matrix[i][j].value === true) {
							collapsedArray[j] = true;
						}

					}
				}
				return collapsedArray;
			},

			updateDisabled(ind) {

				const collapsedArray = this.colapceMatrix();
				this.changeValues = collapsedArray.filter(item => item);

				if(ind === 0 && this.matrix[ind].length === 1) {
					for(let j = 0; j < this.matrix[ind].length; j++) {
						this.matrix[ind][j].disabled = false;
					}
				}

				if(this.matrix.length === 1) {
					for(let j = 0; j < this.matrix[0].length; j++) {
						this.matrix[0][j].disabled = false;
					}
					return;
				}

				for(let i = 0; i < this.matrix.length; i++) {
					for(let j = 0; j < this.matrix[i].length; j++) {

						if(ind !== i ) {

							if(collapsedArray[j] === true && !this.matrix[i][j].value ) {

								this.matrix[i][j].disabled = true;

							} else {

								this.matrix[i][j].disabled = false;

							}

						}

					}

				}

			},

			updateMatrix() {
				this.field.items.forEach((item, index) => {
					item.value.forEach((field, index) => {
						this.matrix[index] = [];
						this.matrix[index].push(
							{
								disabled: false,
								value: field.value
							}
						)
					})
				})
			},


			addSchedule() {

				const collapsedArray = this.colapceMatrix();
				this.changeValues = collapsedArray.filter(item => item);

				const newSlotMatrix = [];

				for(let i = 0; i < collapsedArray.length; i++) {

					newSlotMatrix.push({
						disabled: collapsedArray[i], value: false, id: this.field?.day[i]?.id
					})

				}

				this.matrix.push(
					newSlotMatrix,
				);

				this.localDays.push(
					cloneDeep(this.emptyModel)
				)
				this.localDays[this.localDays.length - 1].id = this.localDays.length;

				this.emmitData();
			},

			removeAllFieldValue(model) {

				for(let key in model) {

					if(typeof model[key] === 'string'){
						if(key === 'value') {
							model[key] = '';
						}
					}

					if(Array.isArray(model[key])) {
						model[key] = [];
					}

					if(typeof model[key] === 'boolean') {
						model[key] = false;
					}

					if(typeof model[key] === 'object' && !Array.isArray(model[key])) {
						this.removeAllFieldValue(model[key]);
					}

				}

			},

			updateLocalValue() {
				if(this.field.items && this.field.items.length) {
					const [first] = this.field.items;
					const copyFirstModel = cloneDeep(first);
					this.removeAllFieldValue(copyFirstModel)
					this.emptyModel = copyFirstModel;
					this.localValue = this.field.items.reduce((acc, cur, index) => {
						acc[index] = cur.value;
						return acc;
					}, [])

					// this.localValue

					this.localDays = this.field.items;

					for(let k = 0; k < this.field.items.length; k++) {

						this.matrix[k] = [];

						for(let i = 0; i < this.field.day.length; i++) {
							this.matrix[k][i] = {
								id: this.field.day[i].value,
								disabled: false,
								value: this.field.items[k].value.includes(this.field.day[i].value)
							}
						}

					}

					for(let j = 0; j < this.field.items.length; j++) {
						this.updateDisabled(j, false);
					}

				}

				const collapsedArray = this.colapceMatrix();
				this.changeValues = collapsedArray.filter(item => item);


			},

			emmitData() {
				let data = [];
				this.localDays.forEach((item, index) => {
					const value = this.matrix[index]
					.filter(elem => elem.value)
					.reduce((acc, curr) => {
						acc.push(curr.id);
						return acc;
					},[])

					if(item.dayOff.value || item.startTime[0] && item.startTime[1]) {
						item.breaksDisabled = false;
					} else {
						item.breaksDisabled = true;
						item.breaks = [];
					}

					data = [
						...data,
						{
							id: item.id,
							dayOff: item.dayOff.value,
							value,
							startTime: item.startTime,
							comment: item.comment.value,
							breaks: item.breaks
						}
					]

				})
				this.$emit('emmitData', data);
			}
		},

		computed: {

			computedCheckLastChange() {
				return this.matrix[this.matrix.length - 1].some(item => item.value);
			},

			computedAvailableButton() {
				return this.changeValues?.length && this.changeValues.length < this.field?.day?.length;
			},

			computedClass() {
				return [
					'field-toggle--' + (this.field?.size || 'l'),
				];
			},
			computedClassOptions() {
				return this.field?.optionsClassNames?.reduce((acc, cur, index) => {
					acc[index] = cur;
					return acc
				}, {});
			}
		},
		watch: {

			field: {
				immediate: true,
				handler() {
					this.updateLocalValue();
					this.emmitData();
				}
			},

			// modelValue: {
			// 	immediate: true,
			// 	handler() {
			// 		console.log()
			// 		this.updateLocalValue();
			// 	}
			// }
		}
	}
</script>